export interface ISubscription {
	id:number;
	receipt:string;
	accountId:number; // account id of the one paying the subscription
	familyId:number;
	expirationTime?:number;
	cancellationTime?:number;
	disabled:boolean;
	platform:SubscriptionPlatform;
	name:string;
}

export interface ISubscribe {
	receipt:string;
	rawReceipt:string;
	platform:SubscriptionPlatform;
}

export enum SubscriptionPlatform {
    UNKNOWN ="UNKNOWN",
    APPLE = "APPLE", 
	GOOGLE = "GOOGLE", 
	WEB = "WEB",
    APPLE_TEST = "APPLE_TEST", 
	GOOGLE_TEST = "GOOGLE_TEST", 
	WEB_TEST = "WEB_TEST",
	CAMPAIGN = "CAMPAIGN",
}


// WEBPACK FOOTER //
// ./src/app-types/websocket/subscription.types.ts